import { lazy } from "react";
import Loadable from "components/Loadable";

const SliderList = Loadable(
  lazy(() => import("features/slider/components/List"))
);
const SliderPage = Loadable(
  lazy(() => import("features/slider/components/Page"))
);

const routes = {
  path: "slider",
  children: [
    { path: "", element: <SliderList /> },
    { path: "add", element: <SliderPage /> },
    { path: "edit/:sliderID?", element: <SliderPage /> },
  ],
};

export default routes;
